<template>
  <div
    :class="
      embedded
        ? 'georef-embed'
        : invalid
        ? 'mb-4 georef-card georef-card--error'
        : 'mb-4 georef-card georef-card--warn'
    "
  >
    <div
      v-if="!embedded"
      class="d-flex align-center georef-card__header"
      @click="expanded = !expanded"
    >
      <div class="flex-grow-1 overflow-hidden pr-2">
        <div
          class="subtitle-2 text-truncate"
          :class="{ 'error--text': invalid }"
        >
          {{ fileName }}
        </div>
        <div
          class="text-caption"
          :class="invalid ? 'error--text' : 'grey--text'"
        >
          {{ headerHint }}
        </div>
      </div>
      <v-icon :color="invalid ? 'error' : undefined">
        {{ expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
      </v-icon>
    </div>
    <v-expand-transition>
      <div v-show="embedded || expanded" :class="embedded ? '' : 'georef-card__body'">
        <div
          class="text-caption mb-3"
          :class="invalid ? 'error--text' : ''"
        >
          File PDF thường không có thông tin tọa độ. Vui lòng nhập hệ tọa độ và
          vùng bao trước khi tạo bộ dữ liệu.
        </div>
        <field-group
          item-text="name"
          item-value="code"
          :value="item.srs"
          filled
          :items="srsList"
          required
          label="Hệ tọa độ"
          no-label
          typeInput="v-autocomplete"
          @input="patch({ srs: $event })"
        ></field-group>
        <v-row dense @paste.capture="onPasteBbox">
          <v-col cols="6">
            <field-group
              :value="item.min_x"
              filled
              typeInput="number"
              step="any"
              label="Min X"
              no-label
              :rules="numberRules"
              @input="patch({ min_x: $event })"
            ></field-group>
          </v-col>
          <v-col cols="6">
            <field-group
              :value="item.min_y"
              filled
              typeInput="number"
              step="any"
              label="Min Y"
              no-label
              :rules="numberRules"
              @input="patch({ min_y: $event })"
            ></field-group>
          </v-col>
          <v-col cols="6">
            <field-group
              :value="item.max_x"
              filled
              typeInput="number"
              step="any"
              label="Max X"
              no-label
              :rules="[...numberRules, greaterThanMinX]"
              @input="patch({ max_x: $event })"
            ></field-group>
          </v-col>
          <v-col cols="6">
            <field-group
              :value="item.max_y"
              filled
              typeInput="number"
              step="any"
              label="Max Y"
              no-label
              :rules="[...numberRules, greaterThanMinY]"
              @input="patch({ max_y: $event })"
            ></field-group>
          </v-col>
        </v-row>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
import { parseBboxPaste } from '@utils/geo-pdf'

export default {
  props: {
    value: { type: Object, default: () => ({}) },
    fileName: { type: String, default: '' },
    srsList: { type: Array, default: () => [] },
    invalid: { type: Boolean, default: true },
    embedded: Boolean,
  },
  data: () => ({
    expanded: true,
    numberRules: [
      (v) =>
        (v !== null && v !== undefined && String(v).trim() !== '') ||
        'Không thể bỏ trống',
      (v) => !Number.isNaN(Number(v)) || 'Giá trị không hợp lệ',
    ],
  }),
  computed: {
    item() {
      return this.value || {}
    },
    headerHint() {
      if (this.invalid) return 'PDF thường · Thiếu tọa độ'
      return 'Đã nhập tọa độ'
    },
  },
  methods: {
    patch(partial) {
      this.$emit('input', Object.assign({}, this.item, partial))
    },
    onPasteBbox(event) {
      const clipboard =
        event.clipboardData ||
        (event.originalEvent && event.originalEvent.clipboardData)
      const text = clipboard ? clipboard.getData('text') : ''
      const bbox = parseBboxPaste(text)
      if (!bbox) return
      event.preventDefault()
      this.patch(bbox)
    },
    greaterThanMinX(v) {
      const minX = Number(this.item.min_x)
      const maxX = Number(v)
      if (Number.isNaN(minX) || Number.isNaN(maxX)) return true
      return maxX > minX || 'Max X phải lớn hơn Min X'
    },
    greaterThanMinY(v) {
      const minY = Number(this.item.min_y)
      const maxY = Number(v)
      if (Number.isNaN(minY) || Number.isNaN(maxY)) return true
      return maxY > minY || 'Max Y phải lớn hơn Min Y'
    },
  },
}
</script>

<style scoped>
.georef-card--warn {
  background: #fff8e1;
  border: 1px solid #ffe082;
  border-radius: 6px;
}
.georef-card--error {
  background: #ffebee;
  border: 1px solid #ef9a9a;
  border-radius: 6px;
}
.georef-card__header {
  padding: 12px;
  cursor: pointer;
  user-select: none;
}
.georef-card__body {
  padding: 0 12px 12px;
}
</style>
